import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import Header from "../../components/Header";
import BgImage from "../../components/BgImage";
import { countIssues } from "../../actions/issue";
import { listIndustries } from "../../actions/industry";
import { Bar } from "react-chartjs-2";

const StatisticsByIndustry = ({ countIssues, listIndustries }) => {
  const [industries, setIndustries] = useState([]);

  const state = {
    labels: industries.map((x) => x.name),
    datasets: [
      {
        backgroundColor: "#00408A",
        borderColor: "rgba(0,0,0,1)",
        borderWidth: 1,
        data: industries.map((x) => x.reportsCount),
      },
    ],
  };

  useEffect(() => {
    statsByIndustry();
  }, []);

  const countIndustry = useCallback(async (industryId) => {
    let count = await countIssues({ "industry.id": industryId });
    return count;
  }, []);

  const statsByIndustry = async () => {
    let industries = await listIndustries();

    let promises = [];
    for (let i = 0; i < industries.length; ++i) {
      promises.push(countIndustry(industries[i].id));
    }
    const counts = await Promise.all(promises);
    for (let i = 0; i < industries.length; ++i) {
      industries[i].reportsCount = counts[i];
    }
    setIndustries(industries);
  };

  return (
    <>
      <Header></Header>
      <BgImage></BgImage>
      <div className="container mx-auto">
        <div className="text-2xl text-center mt-10 uppercase">
          Статистика о делатности
        </div>
        <Bar
          data={state}
          options={{
            legend: {
              display: false,
            },
          }}
        />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  countIssues,
  listIndustries,
};

export default connect(null, mapDispatchToProps)(StatisticsByIndustry);
